import { Component, Prop, Vue } from 'vue-property-decorator';

import {
  AnalysisRunningMode,
  AnalysisWalkingMode,
  AnalysisType,
} from '@/components/analysis/steps/type/AnalysisStepType';
import { StepsKeys } from '@/plugins/podolib/services/analysis';

@Component
export default class AnalysisStep extends Vue {
  @Prop({ required: true }) private title!: string;
  @Prop({ default: null }) private subtitle!: string | null;
  @Prop(Boolean) private transparent!: boolean;

  get patient() {
    return this.$pdc.analysis!.entityPatient!;
  }

  get stepType() {
    return this.$pdc.analysis!.getManifestEntry(StepsKeys.Type);
  }

  get smartSubtitle() {
    // Common payload between translations
    const translationPayload = {
      firstName: this.patient.infos.firstName,
      lastName: this.patient.infos.lastName,
    };

    // Return subtitle
    if (this.subtitle) {
      return this.subtitle;
    } else if (this.stepType) {
      switch (this.stepType.type) {
        case AnalysisType.Walking:
          return this.$t('analysis.steps.subtitle.walking', translationPayload);
        case AnalysisType.Running:
          switch (this.stepType.mode) {
            case AnalysisRunningMode.Treadmill:
              return this.$t('analysis.steps.subtitle.running.treadmill', translationPayload);
            case AnalysisRunningMode.Outdoor:
              return this.$t('analysis.steps.subtitle.running.outdoor', translationPayload);
            default:
              return this.$t('analysis.steps.subtitle.running', translationPayload);
          }
      }
    }

    return this.$t('analysis.steps.subtitle', translationPayload);
  }
}
